export const findDealerToMotorwayTransfer = (data) => {
	const sorted = (data || []).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
	return sorted.find(({ type }) => type === 'dealer_to_mw') || {};
};
